//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Box from './vnp-input-box';
export default {
  components: {
    'vnp-input-box': Box
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      val: this.value,
      type: "cn",
      cn: [["京", "津", "沪", "渝", "冀", "豫", "云", "辽", "黑", "湘"], ["皖", "鲁", "新", "苏", "浙", "赣", "鄂", "桂", "甘", "晋"], ["蒙", "陕", "吉", "闽", "贵", "粤", "青", "藏", "川", "宁"], ["type", "琼", "使", "领", "学", "", "", "", "del"]],
      en: [["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"], ["Q", "W", "E", "R", "T", "Y", "U", "O", "P"], ["A", "S", "D", "F", "G", "H", "J", "K", "L"], ["type", "Z", "X", "C", "V", "B", "N", "M", "del"]]
    };
  },
  computed: {
    visible: {
      set: function set(val) {
        this.$emit("update:show", val);
      },
      get: function get() {
        return this.show;
      }
    },
    list: function list() {
      return this.type === "en" ? this.en : this.cn;
    }
  },
  watch: {
    show: function show() {
      if (this.show) {
        this.val = this.value;
      }
    }
  },
  methods: {
    handleChangeType: function handleChangeType() {
      this.type = this.type === "en" ? "cn" : "en";
    },
    handleClickKey: function handleClickKey(val) {
      if (val) {
        this.$refs.inputBox.setValue(val);
      }
    },
    handleActiveChange: function handleActiveChange(activeIndex) {
      if (activeIndex === 0) {
        this.type = "cn";
      } else {
        this.type = "en";
      }
    },
    handleDel: function handleDel() {
      this.$refs.inputBox.del();
    },
    finish: function finish() {
      this.$emit("input", this.val);
      this.visible = false;
    }
  }
};